import { render, staticRenderFns } from "./Xxgg.vue?vue&type=template&id=91ff5710&scoped=true&"
import script from "./Xxgg.vue?vue&type=script&lang=js&"
export * from "./Xxgg.vue?vue&type=script&lang=js&"
import style0 from "./Xxgg.vue?vue&type=style&index=0&id=91ff5710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ff5710",
  null
  
)

export default component.exports